import { render, staticRenderFns } from "./FreeBoards.vue?vue&type=template&id=7b659e2d"
import script from "./FreeBoards.vue?vue&type=script&lang=js"
export * from "./FreeBoards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports